import { provider } from "@grassrootly/api/providers";

export type ForgotPasswordPayload = {
  email: string;
};

export const ForgotPassword = async (params: ForgotPasswordPayload): Promise<boolean> =>
  provider.Request<ForgotPasswordPayload, boolean>("/auth/forgot-password", params);
